import type { SVGProps } from 'react'
const LineCloseCircle = (props: SVGProps<SVGSVGElement>) => (
	<svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		width={24}
		height={24}
		fill="none"
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			d="M2 12C2 6.485 6.485 2 12 2s10 4.485 10 10-4.485 10-10 10S2 17.515 2 12m1.5 0c0 4.685 3.815 8.5 8.5 8.5s8.5-3.815 8.5-8.5-3.815-8.5-8.5-8.5S3.5 7.315 3.5 12m8.5-1.06 3.22-3.22 1.06 1.06L13.06 12l3.22 3.22-1.06 1.06L12 13.06l-3.22 3.22-1.06-1.06L10.94 12 7.72 8.78l1.06-1.06z"
			clipRule="evenodd"
		/>
	</svg>
)
export { LineCloseCircle }
